import Global from "@/scripts/Global";

export class Logging {
    constructor(){}

    static Log(/**/){  
        if(Global.isDevelop() || Global.isTest() || Global.isStage()){
            console.log(new Date().toDateString() + " "+ new Date().toLocaleTimeString() , Array.prototype.slice.call(arguments))
        }              
    }

    static Warn(/**/){
        if(Global.isDevelop() || Global.isTest() || Global.isStage()){
            console.warn(new Date().toDateString() + " "+ new Date().toLocaleTimeString() , Array.prototype.slice.call(arguments))
        }
    }

    static Info(/**/){
        if(Global.isDevelop() || Global.isTest() || Global.isStage()){
            console.info(new Date().toDateString() + " "+ new Date().toLocaleTimeString() , Array.prototype.slice.call(arguments))
        }
    }

    static Error(/**/){
        if(Global.isDevelop() || Global.isTest() || Global.isStage()){
            console.error(new Date().toDateString() + " "+ new Date().toLocaleTimeString() , Array.prototype.slice.call(arguments))
        }
    }
    
    static Signal(/**/){
        if(Global.isDevelop() || Global.isTest() || Global.isStage()){
            // console.log("%c" + new Date().toDateString() + " "+ new Date().toLocaleTimeString() + " --Signal >>>>>>", 'background: green; color: yellow' ,Array.prototype.slice.call(arguments))
        }
    }

    static Debug(/**/){
        if(Global.isDevelop() || Global.isTest() || Global.isStage()){
            console.log("%c" +  new Date().toLocaleTimeString() + " --Debug  >>>>>>", 'background: black; color: yellow' ,Array.prototype.slice.call(arguments))        
        }
    }
}  
